import { createContext } from 'react';

const useTeamDashboardContext = createContext();
export default useTeamDashboardContext;
